import { createContext } from "react";
import { Language } from "consumerhouse-shared";

export interface LanguageContextState {
    language: Language;
    setLanguage: (val: Language) => void;
}

export const LanguageContext = createContext<LanguageContextState>({ language: "nl", setLanguage: () => {} });
